export const packageList = [
  {
    name: 'dbc',
    activeRule: ['pda'],
  },
]

export const remoteModuleConfig = {
  dev: ['dbc'],
  stg: ['dbc'],
  uat: ['dbc'],
  prd: ['dbc'],
}



// WEBPACK FOOTER //
// ./src/layout/router/remote/package-list/oem/index.js